import { useDispatch, useSelector } from 'react-redux';
import Sensors from 'redux/Sensors';
import Notifications from 'redux/Notifications';

const useSensors = () => {
  const dispatch = useDispatch();

  const isFetchingSensors = useSelector(Sensors.getIsFetchingSensors);

  const sensors = useSelector(Sensors.getSensors);

  const fetchSensors = () => {
    if (!isFetchingSensors) {
      dispatch(Sensors.startFetch());
      return dispatch(Sensors.fetchSensors()).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  return {
    sensors,
    isFetchingSensors,

    fetchSensors,
  };
};

export default useSensors;
